import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import * as XLSX from 'xlsx';

import { api_crud_route, api_list_route, endpoints } from './Config';

import { reqGET, reqPOST, reqDELETE } from '../../../Utils';

import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import Hosts from '../../../Hosts';
import { language } from './Language';
import { color } from '../../WEBContent/Color';
import { icon } from '../../WEBContent/Icon';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [file_loading, set_file_loading] = useState(false);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    // const [permissions, set_permissions] = useState({})
    const [selectedRows, setSelectedRows] = useState([]);

    const handleRowClick = (id) => {
        document.getElementById('c_' + id)?.click();
    };

    const fetch_id_info = async () => {
        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                setData(res.data);
                //console.log("Dados da bd", res.data)
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create === false) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit === false) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove === false) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name && 0) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create === false) {
                            aux.create = node.create
                        }
                        if (aux.edit === false) {
                            aux.edit = node.edit
                        }
                        if (aux.remove === false) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)
                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await fetch_id_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: color.corPrimaria.rgb,
            cancelButtonColor: color.corVermelha.rgb,
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const handleRowSelected = (state) => {

        setSelectedRows(state.selectedRows);
    };

    const headerStyles = {
        nome: selectedRows.length > 0 ? { backgroundColor: color.corVermelha.rgb, color: color.cor3.hexa } : {},
        idade: selectedRows.length > 0 ? { backgroundColor: color.corVermelha.rgb, color: color.cor3.hexa } : {},
    };

    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber)
            return '';

        // Remove qualquer caractere não numérico
        const cleaned = phoneNumber.replace(/\D/g, '');


        if (cleaned.length <= 9)
            return phoneNumber;

        const countryCode = cleaned.slice(0, 3); // Exemplo: 351

        const phoneNumberWithoutCode = cleaned.slice(3);

        const formattedPhone = phoneNumberWithoutCode.replace(/(\d{3})(?=\d)/g, '$1 ');

        return `+${countryCode} ${formattedPhone}`;
    };


    const traduzPerfil = (profile, lang) => {
        const profilesMapeados = {
            en: {
                'Administrador': 'Admin',
                'Colaborador': 'Collaborator',
                'Desenvolvedor': 'Developer',
                'Empresa': 'Company',
                'Entidade': 'Entity',
                'Gestor de Conteúdos': 'Content Manager',
                'TeamLeader': 'Team Leader',
            },
            pt: {
                'Admin': 'Administrador',
                'Collaborator': 'Colaborador',
                'Developer': 'Desenvolvedor',
                'Company': 'Empresa',
                'Entity': 'Entidade',
                'Content Manager': 'Gestor de Conteúdos',
                'Team Leader': 'TeamLeader',
            },
        };
        return profilesMapeados[lang]?.[profile] || profile;
    };

    const columns = [
        {
            name: language[lang].name,
            selector: 'name',
            width: '50%',
            minWidth: '15% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].sigla,
            selector: 'sigla',
            width: '15%',
            minWidth: '15% !important',
            sortable: true,
            left: true,
        },

        {
            name: language[lang].email,
            selector: 'email',
            width: '25%',
            minWidth: '110px !important',
            sortable: true,
            left: true,

        },
        {
            name: language[lang].contacto,
            selector: 'mobile_phone',
            width: '25%',
            minWidth: '110px !important',
            sortable: false,
            center: true,
            cell: row => <div>{formatPhoneNumber(row.mobile_phone)}</div>,
        },
        {
            name: '',
            right: true,
            export: false,
            width: '13%',
            minWidth: '110px !important',
            cell: row => (
                <span onClick={() => handleRowClick(row.id)} style={{ cursor: 'pointer' }}>
                    {/* Hidden Link for View */}
                    <Link
                        id={'c_' + row.id}
                        className="button button-update button-view p-0 pe-2"
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        replace
                    >
                        <i className={icon.view.className} style={icon.view.style}></i>
                    </Link>

                    {/* Permissions for Edit */}
                    {permissions.current !== null && (permissions.current.edit) ? (
                        <Link
                            className={permissions.current.edit ? "button button-update p-0 px-1" : "d-none"}
                            to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                            replace
                            onClick={(e) => e.stopPropagation()}
                        >
                            <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        </Link>
                    ) : null}

                    {/* Permissions for Delete */}
                    {permissions.current !== null && (permissions.current.remove) && (
                        <button
                            className="button button-delete p-0 ps-2"
                            onClick={(e) => {
                                e.stopPropagation();
                                apagar(row['id']);
                            }}
                            aria-label="Delete Ticket"
                        >
                            <i className={icon.trash.className} style={icon.trash.style}></i>
                        </button>
                    )}
                </span>
            ),
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const externalData = data.filter(entity =>
        entity.entity_type === "2"
    );

    const internalData = data.filter(entity =>
        entity.entity_type === "1"
    );

    const tableDataInternal = {
        columns,
        data: internalData,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const tableDataExternal = {
        columns,
        data: externalData,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    console.log("Todas as Entidades", data);

    /*
    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };    
    */



    const onChangeHandlerFilesEntities = (e) => {
        const { files, dataset } = e.target;
        const { order, langid, lang } = dataset

        let storedFiles = [];
        let filesArray = Array.prototype.slice.call(files);

        filesArray.forEach(async (v) => {

            if (v.name.includes('.xls') || v.name.includes('.csv')) {

                set_file_loading(true)

                const file = v;
                const reader = new FileReader();

                reader.onload = async (event) => {
                    const workbook = XLSX.read(event.target.result, { type: 'binary', cellDates:true, dateNF:'dd-mm-yyyy'});
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    const sheetData = XLSX.utils.sheet_to_json(sheet);

                    console.log(sheetData);






                    await reqPOST(Hosts.SIMCore_API + '/intranet/entities/external/' + getTokenInfo().companycode + '/list/array', { dados: sheetData })

                };

                reader.readAsBinaryString(file);
            }

        });

    }

    return (isloading ? (
        <Loader />
    ) : (
        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].entity}</h2>
                    <p>{language[lang].entity} / {language[lang].entity_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="card-header border-0 d-flex justify-content-sm-between">
                                        <h3>{language[lang].entity_externa}</h3>

                                        {permissions.current !== null && (permissions.current.create) && (
                                            <div className="table-header text-end mb-8">
                                                <div className="dropzone-panel mb-lg-0 mb-2">
                                                    <div className="div-form-input col-12 custom-file d-none">
                                                        <label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-entities-0"}>{language[lang].doc_entities_choose}</label>
                                                        <input
                                                            id={"input-files-entities-0"}
                                                            type="file"
                                                            accept=".xls, .xlsx, .csv"
                                                            data-type={'doc'}
                                                            className="dropzone-select btn btn-sm btn-primary me-2 d-none"
                                                            onChange={onChangeHandlerFilesEntities}
                                                            multiple
                                                        />
                                                    </div>
                                                </div>

                                                <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                    to={{ pathname: endpoints.regist }}
                                                    style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                                >
                                                    <span>{language[lang].add_new}</span>
                                                </Link>
                                            </div>
                                        )}
                                    </div>

                                    {/*
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                    */}

                                    {/* Entidades Externas */}
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="pb-10">
                                                <div className="div-table">
                                                    <div className="table-body">
                                                        <DataTableExtensions {...tableDataExternal}>
                                                            <DataTable
                                                                noDataComponent={language[lang].table_empty}
                                                                noHeader
                                                                pagination
                                                                exportHeaders
                                                                paginationComponentOptions={defaultComponentOptions}
                                                                paginationPerPage={25}
                                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                                onRowClicked={(row) => handleRowClick(row.id)}
                                                                customStyles={{
                                                                    rows: {
                                                                        style: {
                                                                            cursor: 'pointer',
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                        </DataTableExtensions>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Entidades Internas */}
                                    {/* <div className="card mb-5 mb-xl-8">
                                        <div className="card-body">
                                            <h3 style={{ marginBottom: '2%' }}>{language[lang].entity_interna}</h3>
                                            <div className="pb-10">
                                                <div className="div-table">
                                                    <div className="table-body">
                                                        <DataTableExtensions {...tableDataInternal}>
                                                            <DataTable
                                                                noDataComponent={language[lang].table_empty}
                                                                noHeader
                                                                pagination
                                                                exportHeaders
                                                                paginationComponentOptions={defaultComponentOptions}
                                                                paginationPerPage={25}
                                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                            />
                                                        </DataTableExtensions>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    ));
}